export default __webpack_public_path__ + "static/media/usd.1a93d95c.svg";